const KeywordsMaker = (keywords) => {
  const nonEmptyKeywords = keywords.filter((keyword) => keyword !== '');
  const words = nonEmptyKeywords.length > 0 ? nonEmptyKeywords.join('; ') : '';
  return words;
};

export default KeywordsMaker;
